<script lang="ts">
  import "../app.css";
  import { auth } from "$lib/stores/auth.svelte";
  import { i18n } from "$lib/stores/locale.svelte";
  import { theme } from "$lib/stores/theme.svelte";
  import { userPrefs } from "$lib/stores/userPrefs.svelte";
  import { ToastViewport } from "$lib/ui";

  let { children }: { children: import("svelte").Snippet } = $props();

  $effect(() => {
    theme.init();
  });

  $effect(() => {
    document.documentElement.lang = i18n.locale;
  });

  $effect(() => {
    void auth.init();
  });

  $effect(() => {
    if (auth.resolved && auth.isAuthenticated) userPrefs.ensureLoaded();
  });
</script>

{@render children()}
<ToastViewport />
